import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';

const FUNCTION_CODE = 'UPDATE_MISSION_BY_ID';

export async function updateMissionById(
    userToken: string,
    updatedMission: Record<string, unknown>,
) {

    try {
        const response = await axios({
            method: 'patch',
            url: `${URL}/missions/${updatedMission.id}/`,
            data: updatedMission,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return await response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la mis à jour d\'une mission',
            error: error
        });
    }
}
